import React, { Fragment } from 'react';
import { useSelector } from 'react-redux';

import { sendEventClick } from 'src/api/tracker';

import LocationRadiusContainer from 'src/containers/LocationRadiusContainer';
import FormSendContainer from 'src/containers/FormSendContainer';
import WorkplaceContainer from 'src/containers/WorkplaceContainer';
import KeywordContainer from 'src/containers/KeywordContainer';

import ChevronRight from '@mdi/svg/svg/chevron-right.svg';
import UkrainianFriendlyIcon from 'src/images/ukrainian-friendly.svg';

import './SearchForm.scss';

const SearchForm = () => {
  const searchURL = useSelector(({ configReducer }) => configReducer.searchURL);
  const searchTitle = 'Jakiej pracy szukasz?';
  const searchCopy = 'Szukaj';
  const advancedSearchCopy = 'Wyszukiwanie zaawansowane';
  const ukrainianFriendlyCopy = 'Pобота';
  const ukrainianFriendlyHref = 'https://robota.pracuj.pl/';

  const renderTitle = () => (
    <div styleName="search-form__title">
      <h2 styleName="search-title">{searchTitle}</h2>
      <h2 styleName="search-title search-title--desktop">{searchCopy}</h2>
    </div>
  );

  const renderContent = () => (
    <>
      <div styleName="search-form__keyword">
        <KeywordContainer />
      </div>
      <div styleName="search-form__workplace">
        <WorkplaceContainer />
      </div>
      <div styleName="search-form__radius">
        <LocationRadiusContainer />
      </div>
      <div styleName="search-form__form-send">
        <FormSendContainer />
      </div>
    </>
  );

  const renderButtons = () => (
    <>
      <button
        data-test="advanced-search"
        styleName="advanced-search__action"
        onClick={() => {
          sendEventClick('search_advanced');
        }}
        type="submit"
      >
        {advancedSearchCopy}
        <ChevronRight
          styleName="advanced-search__action-chevron"
          viewBox="0 0 24 24"
        />
      </button>
      <a
        data-test="anchor-ukrainian-friendly"
        href={ukrainianFriendlyHref}
        onClick={() => {
          sendEventClick('search_jobOffersUa');
        }}
        styleName="advanced-search__action"
      >
        <UkrainianFriendlyIcon
          styleName="advanced-search__action-icon"
          viewBox="0 0 21 20"
        />
        {ukrainianFriendlyCopy}
        <ChevronRight
          styleName="advanced-search__action-chevron"
          viewBox="0 0 24 24"
        />
      </a>
    </>
  );

  return (
    <form
      action={searchURL}
      autoComplete="off"
      data-test="form-search"
      id="search-searchForm"
      method="post"
    >
      <div styleName="search-form">
        {renderTitle()}
        {renderContent()}
      </div>
      <div styleName="advanced-search">{renderButtons()}</div>
    </form>
  );
};

export default SearchForm;
